<template>
  <aside class="sidebar">
    <logo />
    <slot></slot>
  </aside>
</template>

<script>
  import Logo from './layout-default-logo';
  export default {
    components: {
      Logo
    }
  };
</script>
